export default __webpack_public_path__ + "static/media/supportChatIcon.1990ce72.svg";